// shared/utils
// Wallet helpers for type detection and guards
// - Depends on shared/types (WalletType, Account)
// - Depends on shared/constants (MPC, EVM)
// Keep these helpers pure and side-effect free. Update normalization logic if constants change casing.

// types
import { WalletType, Account } from '@/components/shared/types'
// constants
import { MPC, EVM } from '@/components/shared/constants'

/**
 * Normalize an incoming wallet type to the canonical constant (MPC or EVM).
 * Case-insensitive by design: adjust the normalization to match constants' casing.
 * If constants MPC/EVM are lowercase, prefer `wallet.toLowerCase()` here.
 * @param wallet WalletType value to normalize
 * @returns WalletType - canonical constant (MPC or EVM)
 */
export const getWalletType = (wallet: WalletType): WalletType => {
  return wallet.toLocaleUpperCase() === MPC ? MPC : EVM
}

/**
 * Convenience predicate: whether the given account is an MPC wallet
 * @param account Account
 * @returns boolean
 */
export const isMpcWalletType = (account: Account) => {
  return getWalletType(account.wallet) === MPC
}

/**
 * Convenience predicate: whether the given account is an EVM wallet
 * @param account Account
 * @returns boolean
 */
export const isEvmWalletType = (account: Account) => {
  return getWalletType(account.wallet) === EVM
}
